<template>
  <v-card elevation="1" class="ma-0">
    <v-row justify="center" align="center" class="cards-header-dashboard">
      <v-col cols="2" justify="center" align="center">
        <v-icon size="35" color="black">
          {{ icon }}
        </v-icon>
      </v-col>
      <v-col cols="8">
        <v-row dense justify="center" align="center">
          <v-col sm="12" justify="center" align="start">
            <div class="caption font-weight-light">
              {{ heading }}
            </div>
          </v-col>
        </v-row>
        <v-row dense justify="center" align="center">
          <v-col sm="12" justify="center" align="start">
            <div class="button font-weight-medium">
              {{ value }}
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  export default {
    name: 'InformativoGenerico',

    props: {
      icon: String,
      heading: String,
      value: String
    },

    data() {
      return {
        fireData: []
      };
    }
  };
</script>